import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import Logo from '@/components/Logo';
import PortalButton from '@/components/PortalButton';

const links = [
  { href: '#services', label: 'Ydelser', key: 'services' },
  { href: '#how-it-works', label: 'Sådan fungerer det', key: 'how-it-works' },
  { href: '/erhverv', label: 'Erhverv', key: 'business' },
  { href: '#contact', label: 'Kontakt', key: 'contact' },
];

export const SiteHeader = ({ onMenuChange }) => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  useEffect(() => { onMenuChange?.(open); }, [open, onMenuChange]);
  useEffect(() => {
    const escape = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('keydown', escape);
    return () => document.removeEventListener('keydown', escape);
  }, []);
  const renderLink = (item, prefix) => item.href.startsWith('/') ? (
    <Link key={item.key} to={item.href} onClick={close} data-testid={`${prefix}-${item.key}-link`}>{item.label}</Link>
  ) : (
    <a key={item.key} href={item.href} onClick={close} data-testid={`${prefix}-${item.key}-link`}>{item.label}</a>
  );
  return (
    <header className="e-header" data-testid="site-header">
      <div className="e-container e-header-inner">
        <Link to="/" className="e-header-logo" aria-label="E Service – forsiden" data-testid="header-home-link"><Logo data-testid="header-logo" /></Link>
        <nav className="e-desktop-nav" aria-label="Hovedmenu" data-testid="desktop-navigation">{links.map((item) => renderLink(item, 'nav'))}</nav>
        <div className="e-header-actions">
          <div className="e-header-auth"><PortalButton /></div>
          <Link to="/book" className="e-button e-header-book" data-testid="book-now-header-btn">Book tid</Link>
          <button className="e-menu-button" type="button" aria-label={open ? 'Luk menu' : 'Åbn menu'} aria-expanded={open} aria-controls="mobile-navigation" onClick={() => setOpen(!open)} data-testid="menu-open-btn">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && <nav id="mobile-navigation" className="e-mobile-nav" aria-label="Mobilmenu" data-testid="menu-dropdown">
        {links.map((item) => renderLink(item, 'mobile-nav'))}
        <Link to="/blog" onClick={close} data-testid="mobile-nav-blog-link">Blog</Link>
      </nav>}
    </header>
  );
};